import { Box, BoxProps } from '@mui/material';
import { ReactElement } from 'react';

interface IButtonsContainerProps extends BoxProps {
  children: ReactElement | ReactElement[];
  variant?: string;
}

export const ButtonsContainer: React.FC<React.PropsWithChildren<IButtonsContainerProps>> = (props) => {
  const { children, variant = 'horizontal' } = props;

  return (
    <Box
      {...props}
      sx={
        variant === 'horizontal'
          ? {
              display: 'inline-flex',
              gap: '12px',
              ...props.sx
            }
          : variant === 'vertical'
            ? {
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                ...props.sx
              }
            : {
                display: 'inline-flex',
                gap: '12px',
                ...props.sx
              }
      }
    >
      {children}
    </Box>
  );
};
